module.exports = __webpack_public_path__ + "media/images/emblems/Grandval-coat_of_arms-4f7883c697e7d2bcfd38caf2647e8016.svg";